import React, { Suspense } from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

// Lazy load game components
const TicTacToe = React.lazy(() => import("./games/TicTacToe"));
const SnakeGame = React.lazy(() => import("./games/SnakeGame"));
const BoxClickerGame = React.lazy(() => import("./games/BoxClicker"));
const BombRewardGame = React.lazy(() => import("./games/BombRewardGame"));
const MemoryMatch = React.lazy(() => import("./games/MemoryMatch"));
const WordRushGame = React.lazy(() => import("./games/WordRushGame"));
const SudokuGame = React.lazy(() => import("./games/SudokuGame"))
// Map gameId to component
const gameComponents = {
    tictactoe: TicTacToe,
    snake: SnakeGame,
    boxclicker: BoxClickerGame,
    bombreward: BombRewardGame,
    memorymatch: MemoryMatch,
    wordrushgame: WordRushGame,
    sudokugame: SudokuGame,
};

export default function GamePlayer({ gameId, onClose }) {
    const GameComponent = gameComponents[gameId];

    if (!GameComponent) {
        return (
            <Box sx={{ p: 2 }}>
                <Typography variant="h5" color="error">
                    Game not found.
                </Typography>
            </Box>
        )
    }

    return (
        <Box
            sx={{
                maxWidth: "100vw",
                maxHeight: "100vh",
                bgcolor: "background.default",
                color: "text.primary",
                display: "flex",
                flexDirection: "column",
                marginTop: "20px"
            }}
            role="dialog"
            aria-modal="true"
            aria-labelledby="game-title"
        >
            <Suspense fallback={<Typography sx={{ p: 4, textAlign:"center"}}>Loading game...</Typography>}>
                <GameComponent />
            </Suspense>
        </Box>
    )
}